namespace TabAurous.ECommerce {
    export namespace AddressSelectForPickUpService {
        export const baseUrl = 'ECommerce/AddressSelectForPickUp';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ECommOrderAddressRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommerce/AddressSelectForPickUp/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>AddressSelectForPickUpService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
